import { render } from "./sceneSwitchList.vue?vue&type=template&id=800672ca&scoped=true&ts=true"
import script from "./sceneSwitchList.vue?vue&type=script&lang=ts"
export * from "./sceneSwitchList.vue?vue&type=script&lang=ts"

import "./sceneSwitchList.vue?vue&type=style&index=0&id=800672ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-800672ca"]])

export default __exports__